import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Card, Container, Row, Col, Dropdown, Pagination } from 'react-bootstrap';
import './ProductList.css';

const ProductList = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [sortBy, setSortBy] = useState('createdAt');
  const [order, setOrder] = useState('desc');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(12); // 每頁顯示的商品數量
  const [categoryName, setCategoryName] = useState('');

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://shopapi.nogi46.me/api/products', {
        params: {
          sortBy,
          order,
          page,
          limit,
          category: categoryId,
        },
      });
      setProducts(response.data.products);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchCategoryName = async () => {
    try {
      const response = await axios.get(`https://shopapi.nogi46.me/api/categories/${categoryId}`);
      setCategoryName(response.data.name);
      document.title = `${response.data.name}`;
    } catch (error) {
      console.error('Error fetching category:', error);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCategoryName();
  }, [categoryId, sortBy, order, page, limit]);

  const handleSortChange = (sortOption) => {
    if (sortOption.sortBy === 'createdAt') {
      setSortBy('_id'); // 使用 _id 模擬建立時間排序
    } else {
      setSortBy(sortOption.sortBy);
    }
    setOrder(sortOption.order);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <Container>
      {/* 排序選項 */}
      <Dropdown className="mb-4">
        <Dropdown.Toggle className="dropdown-toggle" id="dropdown-sort">
          排序方式
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu">
          <Dropdown.Item className="dropdown-item" onClick={() => handleSortChange({ sortBy: '_id', order: 'desc' })}>
            新增日期 (最新)
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item" onClick={() => handleSortChange({ sortBy: '_id', order: 'asc' })}>
            新增日期 (最舊)
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item" onClick={() => handleSortChange({ sortBy: 'price', order: 'asc' })}>
            價格 (低到高)
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item" onClick={() => handleSortChange({ sortBy: 'price', order: 'desc' })}>
            價格 (高到低)
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {/* 商品列表 */}
      <Row>
        {products.map((product) => (
          <Col key={product.productId} xs={6} sm={4} md={3} lg={2} className="mb-4">
            <Link to={`/product/${product.productId}`} className="product-link">
              <Card className="product-card">
                <Card.Img variant="top" src={product.images[0]} className="product-image" />
                <Card.Body className="product-body">
                  <Card.Title className="product-title">{product.name}</Card.Title>
                  <Card.Text className="product-price">${product.price}</Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      {/* 分頁控制 */}
      <Pagination className="pagination justify-content-center mt-4">
        {[...Array(totalPages).keys()].map(num => (
          <Pagination.Item key={num + 1} active={num + 1 === page} onClick={() => handlePageChange(num + 1)} className="page-item">
            {num + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </Container>
  );
};

export default ProductList;
